/****************************************************************************************************/
/* #region Editor Detection */
/****************************************************************************************************/

/**
 * Returns true when the script is running inside the Sitefinity page editor
 * or admin shell, so callers can skip animations and interactive behaviour
 * that would interfere with editing.
 */
export function isSitefinityEditor() {
    // Body classes Sitefinity adds in legacy and new zone editor modes
    if (document.body.classList.contains('sfPageEditor') ||
        document.body.classList.contains('-sf-new-zone-editor')) {
        return true;
    }

    // Running in the parent adminapp shell (script loaded outside the iframe)
    if (window.location.pathname.includes('/adminapp')) {
        return true;
    }

    // Script is running inside an iframe — Sitefinity loads page assets into
    // an editor iframe, so being framed is a strong signal we're in the editor.
    // The sf_version query param is appended by Sitefinity in edit/preview mode
    // and guards against unrelated iframe embeds.
    if (window.self !== window.top &&
        window.location.search.includes('sf_version')) {
        return true;
    }

    return false;
}

/* #endregion */
/****************************************************************************************************/

/****************************************************************************************************/
/* #region DOM Utilities */
/****************************************************************************************************/

/**
 * Fades an element in by stepping its opacity up in increments.
 * @param {HTMLElement} el
 * @param {number} speed - milliseconds between each opacity step
 */
export function fadeIn(el, speed = 50) {
    if (!el) return;
    el.style.display = '';
    let opacity = parseFloat(el.style.opacity) || 0;

    const tick = () => {
        opacity = Math.min(1, opacity + 0.1);
        el.style.opacity = String(opacity);
        if (opacity < 1) setTimeout(tick, speed);
    };

    if (opacity < 1) tick();
}

/**
 * Fades an element out by stepping its opacity down in increments.
 * @param {HTMLElement} el
 * @param {number} speed - milliseconds between each opacity step
 */
export function fadeOut(el, speed = 75) {
    if (!el) return;
    let opacity = parseFloat(el.style.opacity);
    if (isNaN(opacity)) opacity = 1;

    const tick = () => {
        opacity = Math.max(0, opacity - 0.1);
        el.style.opacity = String(opacity);
        if (opacity > 0) {
            setTimeout(tick, speed);
        } else {
            el.style.display = 'none';
        }
    };

    if (opacity > 0) tick();
}

/* #endregion */
/****************************************************************************************************/
